export const teamData = {
    coreTeamMembers: [{
        name: "Mayukh Bhowmick",
        profession: "React Developer",
        clubRole: "Coordinator",
        dept: "CSE",
        year: 3,
        skills: ['ReactJS', 'NodeJS', 'MERN', 'Firebase', 'Java'],
        about: "",
        socialMedia: ['https://github.com/mayukh551', 'https://linkedin.com/in/mayukh-bhowmick-44533a201/', 'https://instagram.com/mayukh_bhowmick_17/', '', '']
    },
    {
        name: "Suryasnata Saha",
        profession: "Front-End Developer",
        clubRole: "Convenor",
        dept: "CSE",
        year: 3,
        skills: ['HTML/CSS', 'JavaScript', 'React', 'C++', 'Python'],
        about: "IT undergrad and Web-Dev enthusiast. Learning every day, bit by bit.",
        socialMedia: ['https://github.com/twinkle2303', 'https://linkedin.com/in/suryasnata-saha-a00a721ba/', 'https://instagram.com/___twinkleee__/', 'https://facebook.com/suryasnata23', 'https://twitter.com/twinkle_2303']
    },
    {
        name: "MD Hasanuj Jaman Hossain",
        profession: "Competitive Programming Enthusiast",
        clubRole: "Event Manager",
        dept: "CSE",
        year: 3,
        skills: ['Competitive Coding', 'Event organization', 'Technical aspects', 'Event Management', 'Public Representation'],
        about: "Reading Books technical magazines, Watching Movies web series youtube, and Games.",
        socialMedia: ['', '', '', 'https://facebook.com/mdhasanujjaman.hossain.5', 'https://twitter.com/hasanuj_md?t=L-8faZkcgzwQ9LlHFu7C8A&s=08']
    },
    {
        name: "Shirsasish Sarkar",
        profession: "PHP Developer",
        clubRole: "Tech Head",
        dept: "CSE",
        year: 3,
        skills: ['Java', 'Python', 'PHP', 'MySQL'],
        about: "",
        socialMedia: ['', '', '', '', '']
    },
    {
        name: "Shagnik Mukherjee",
        profession: "Robotics Engineer",
        clubRole: "Non-Tech Head",
        dept: "CSE",
        year: 3,
        skills: [],
        about: "",
        socialMedia: ['', 'https://linkedin.com/in/shagnik-mukherjee-3980a720b', 'https://instagram.com/dark_star_shines/', '', '']
    },
    {
        name: "MD Saood Khan",
        profession: "Back-End Developer",
        clubRole: "Social Media Head",
        dept: "CSE",
        year: 3,
        skills: ['Competitive Coding', 'Front-end Developing', 'Data Management', 'Problem Solving', 'Leadership'],
        about: "I'm a CSE undergrad. I'm from Kolkata. I like Competitive Coding and I am a bit into Front-End Development. I love to play Cricket, play Video Games and watch Anime. ",
        socialMedia: ['https://github.com/MdSaoodKhan', 'https://linkedin.com/in/md-saood-khan-007/', 'https://instagram.com/thesaoodkhan/', 'https://facebook.com/mdsaood.khan.3/', 'https://twitter.com/TheSaoodKhan']
    }
    ],

    domainManagers: [{
        name: "Soham Saha Roy",
        profession: "MERN Developer",
        clubRole: "WebDev",
        dept: "CSE",
        year: 3,
        skills: [],
        about: "",
        socialMedia: ['https://github.com/infuman69', 'https://linkedin.com/in/soham-saha-roy-788115206/', 'https://instagram.com/n.i.b.asin90/', '', '']
    },
    {
        name: "Rishav Mandal",
        profession: "Android Developer",
        clubRole: "AppDev",
        dept: "CSE",
        year: 3,
        skills: [],
        about: "",
        socialMedia: ['', '', '', '', '']
    },
    {
        name: "Soham Banerjee",
        profession: "Software Security Engineer",
        clubRole: "Cyber Security",
        dept: "CSE",
        year: 3,
        skills: ['ReactJS', 'Angular', 'OpenCV', 'Git', 'C/C++'],
        about: "GSOC contributor @ Fossology and Open source enthusiast",
        socialMedia: ['https://github.com/soham4abc', 'https://linkedin.com/in/soham-banerjee-6091831b3/', 'https://instagram.com/debugginglife_02/', '', '']
    },
    {
        name: "Nishant Thakur",
        profession: "Competitive Programming Enthusiast",
        clubRole: "Competitive Programming",
        dept: "IT",
        year: 3,
        skills: ['JAVA', 'C++', 'C', 'HTML/CSS', 'JAVASCRIPT'],
        about: "I am a student of RCCIIT pursuing a B.tech in IT branch, I like competitive coding and I aspire to be a full-stack web developer in future. ",
        socialMedia: ['https://github.com/Nishantthakur62', 'https://linkedin.com/in/nishant-thakur-a35587200', 'https://instagram.com/nishant_thakur_72_/', 'https://facebook.com/nishantthakur0/', 'https://twitter.com/Nishant27603786']
    },
    {
        name: "Triasis Ghosh",
        profession: "ML Engineer",
        clubRole: "AI/ML",
        dept: "CSE",
        year: 3,
        skills: [],
        about: "",
        socialMedia: ['', 'https://linkedin.com/in/triasis-ghosh-322b27201/', 'https://instagram.com/triasisghosh/', '', '']
    },
    {
        name: "Sayani Patra",
        profession: "ML Engineer",
        clubRole: "Graphics Head",
        dept: "CSE",
        year: 3,
        skills: [],
        about: "",
        socialMedia: ['', 'https://linkedin.com/in/sayani-patra-252571241/', 'https://instagram.com/sayaniandpatra/', '', '']
    },
    {
        name: "Soham Sarkar",
        profession: "Technical Writer",
        clubRole: "Content Head",
        dept: "IT",
        year: 3,
        skills: ['Content Writing', 'Report Writing', 'Team Management', 'Descriptive', 'Persuasive Writing'],
        about: "I am Soham Sarkar of the IT department, I am a Content Writing enthusiast and like to develop content whenever my team requires it, also I write Reports of the events that were held so as to keep a record for future use. At present, I am the Content Writing Head in RccTechz The Official Coding Club Of RCCIIT and The NSS Student Chapter Of RCCIIT.",
        socialMedia: ['https://github.com/sohm1112', 'https://linkedin.com/in/soham-sarkar-b3290b214/', 'https://instagram.com/soham7064/', '', '']
    }
    ],
    graphicsDesigners: [{
        name: "Amit Roy Chowdhury",
        profession: "",
        order: 1,
        clubRole: "Video Animator",
        dept: "IT",
        year: 2,
        skills: [],
        about: "",
        socialMedia: ['', 'https://linkedin.com/in/amit-roy-chowdhury-597993223/', 'https://instagram.com/amit.is.high/', '', '']
    },
    {
        name: "Atalanta Dey",
        profession: "",
        order: 2,
        clubRole: "Video Animator",
        dept: "CSE",
        year: 2,
        skills: ['Graphic Design', 'JAVA', 'PYTHON', 'Web Dev'],
        about: "I enjoy spending my spare time Drawing/Sketching random things I see and try to work on myself by going to the Gym sometimes. Otherwise, I am a coder by night ",
        socialMedia: ['https://github.com/atalantadey', 'https://linkedin.com/in/atalanta-dey-52a920229/', 'https://instagram.com/atalanta_dey/', 'https://facebook.com/atalanta.dey/', 'https://twitter.com/dey_atalanta']
    },
    {
        name: "Swastika Bose",
        profession: "",
        order: 3,
        clubRole: "Content Writer",
        dept: "CSE",
        year: 2,
        skills: ['Python', 'Data Science', 'Cloud Computing', 'AI/ML', 'Web Dev'],
        about: "Presently I am pursuing B.Tech in CSE at RCC Institute of Information Technology. Living my life to the fullest ✨. Working more on AI ML and Data Science. Aspire to be a Data Analyst. ",
        socialMedia: ['https://github.com/swastika07bose', 'https://linkedin.com/in/swastika-bose-25at25', 'https://instagram.com/the_swastikabose?igshid=YmMyMTA2M2Y=', 'https://m.facebook.com/profile.php?id=100005661045208', '']
    },
    {
        name: "Urbi Chakraborty",
        profession: "",
        order: 4,
        clubRole: "Graphics Designer",
        dept: "CSE",
        year: 2,
        skills: ['Web Dev', 'Python programming', 'graphic design'],
        about: "Some languages that I know are Java, Python, C, and C++. I use Figma and Canva for Designing. I can do basic front-end development using: Html, CSS, and Js. Sometimes I use frameworks like Tailwind/Bootstrap. I have used MySQL.Can use Github ",
        socialMedia: ['https://github.com/Urbi-C', 'https://linkedin.com/in/urbi-chakraborty-190bb0227/', 'https://instagram.com/urbi__chakraborty/', '', '']
    },
    {
        name: "Soumyadeep Chakraborty",
        profession: "",
        order: 5,
        clubRole: "Graphics Designer",
        dept: "CSE",
        year: 2,
        skills: ['Graphic Design', 'Competitive Programming', 'Git and Github', 'Front end design'],
        about: "Myself Soumyadeep Chakraborty. I was born and brought up at Jhargram in West Bengal. I completed my schooling there. Currently, I am pursuing B.Tech in Computer Science and Engineering from RCC Institute of Information Technology, Kolkata. My skills include Front End Design, Graphics Design, Communication Skills, and Competitive Coding. My hobbies are chess, reading books, listening to music etc. That's all about myself. Thank you! ",
        socialMedia: ['https://github.com/epicskills1', 'https://linkedin.com/in/soumyadeep-chakraborty-rcc', 'https://instagram.com/63soumya_beyond_the_infinity/', 'https://m.facebook.com/100010841176395/', 'https://mobile.twitter.com/Soumyad26766621']
    },
    {
        name: "Priyojit Kundu",
        profession: "",
        order: 6,
        clubRole: "Graphics Designer",
        dept: "CSE",
        year: 2,
        skills: ['Designer', 'Problem Solver', 'Web Development'],
        about: "I am a student of RCC Institute of Information Technology Kolkata and a Full Stack developer learner with experience building websites and web applications by Wix site tool. I enthusiastically participate in college hackathons to gain experience and skills.I am specializing in C++ and C. Being a Tech freak I enjoy solving technical problems, researching and developing new technologies, and designing software applications for different platforms. I'm a go-getter and a quick learner. I am currently an Official member of the college Graphics Department team (RccTechz).",
        socialMedia: ['', 'https://linkedin.com/in/priyojit-kundu-37a024238', 'https://instagram.com/priyojit11?igshid=YmMyMTA2M2Y=', '', '']
    }
    ],
    techTeam: [{
        name: "Debopom Banerjee",
        profession: "Web Developer",
        order: 1,
        clubRole: "Web Developer",
        dept: "CSE",
        year: 2,
        skills: ['Java', 'Blockchain dev', 'web dev', 'Python'],
        about: "Coding enthusiast with an interest in blockchain and web development.",
        socialMedia: ['https://github.com/Debopom-Banerjee', 'https://linkedin.com/in/debopom-banerjee-a35123215/', '', '', '']
    },
    {
        name: "Arghya Dutta ",
        profession: "React Developer",
        order: 2,
        clubRole: "React Developer",
        dept: "CSE",
        year: 2,
        skills: ['Frontend Web Development', 'C++ & Python programming language', 'Git & GitHub', 'VS-Code', 'Technical Content Writing'],
        about: "I have knowledge of C, C++, and Python programming languages and web technologies like- HTML, CSS, JavaScript, React JS and Bootstrap. I am highly interested in Competitive Programming, Frontend and Backend Web Development, App Development, AI-ML and Blockchain development. I already made some projects using my programming skills, which are already shared in the project section in my LinkedIn profile. ",
        socialMedia: ['https://github.com/arghyadutta080', 'https://linkedin.com/in/arghya-dutta-623617229', 'https://instagram.com/_king_markas_/', 'https://facebook.com/arghya.dutta.9404/', 'https://twitter.com/Arghya_Dutta08']
    },
    {
        name: "Chayandev Bera",
        profession: "Android Developer",
        order: 3,
        clubRole: "Kotlin Developer",
        dept: "CSE",
        year: 2,
        skills: ['C', 'C++', 'HTML', 'CSS', 'Kotlin', 'Android Development', 'Competitive coding'],
        about: "I am Chayandev Bera, a Second-year student of computer science and engineering, I have knowledge of C, C++, Basic python language & Kotlin. Have an interest in Competitive programming, Android development, web site design. I made some basic projects using my knowledge of C++ and made some basic layout designs of the website using HTML CSS and Basic JavaScript, and some Android applications, added in the Project section of my LinkedIn profile .",
        socialMedia: ['https://github.com/Chayandev', 'https://linkedin.com/in/chayandev-bera-324bb5220', '', '', '']
    },
    {
        name: "Sansrita Saha",
        profession: "Python Developer",
        order: 4,
        clubRole: "Web & Python Dev",
        dept: "CSE",
        year: 2,
        skills: ['Front-end Developer', 'Competitive Coder', 'Python Developer'],
        about: "Hello! I am currently a BTech Computer Science Engineering student. I am a dedicated coder and I am currently a Frontend developer. I have a massive interest in AI/ML, App Development. I made two mini projects using C language and Python and some frontend development projects using HTML, CSS, JavaScript and Bootstrap.",
        socialMedia: ['https://github.com/Sansrita', 'https://linkedin.com/in/sansrita-saha-068246228/', 'https://instagram.com/midnight_minutes_16/', 'https://facebook.com/profile.php?id=100079460059655', '']
    },
    {
        name: "Raj Mandal",
        profession: "Web Developer",
        order: 5,
        clubRole: "Web Developer",
        dept: "CSE",
        year: 2,
        skills: ['C++', 'Javascript', 'Node JS', 'Mysql'],
        about: "5 ⭐ Coder @HackerRank in C++|| 1⭐ Coder @CodeChef || Real Life Solution Oriented Thinker|| DSA || Web Development",
        socialMedia: ['', 'https://linkedin.com/in/raj-mandal-72a834247/', '', '', '']
    },
    {
        name: "Souvik Bhattacharya",
        profession: "Web Developer",
        order: 6,
        clubRole: "Competitive Coder",
        dept: "CSE",
        year: 2,
        skills: ['C', 'python', 'html', 'css', 'javascript (beginner level)'],
        about: "I am souvik bhattacharya a student of CSE, 2nd year. I like to learn new things which are under my domain of interest. I used to play chess as a hobby.",
        socialMedia: ['https://github.com/Souvik-Bhattacharya', '', '', '', '']
    },
    {
        name: "Sambit Sarkar",
        profession: "Flutter Developer",
        order: 7,
        clubRole: "Flutter Developer",
        dept: "CSE",
        year: 2,
        skills: ['CP', 'App dev using Flutter', ' Frontend', 'Firebase'],
        about: "Hello, I am a Second-year Btech student, who is very much interested in App Development, and any form of new technologies, learning new things, and also Solving Rubik's Cubes!",
        socialMedia: ['https://github.com/Sscuber03', 'https://linkedin.com/in/sambit-sarkar-12b041212/', 'https://instagram.com/ss_cuber2/', 'https://facebook.com/sambit.sarkar2003/', 'https://twitter.com/Sambits28225539']
    },
    {
        name: "Ranit Das",
        profession: "Web Developer",
        order: 8,
        clubRole: "Web Developer",
        dept: "CSE",
        year: 2,
        skills: ['Web development', 'competitive programming', 'python', 'AI(very beginning stage)'],
        about: "Myself Ranit Das and currently I am working with web development. I have also done some competitive programming. I actually use python and c in competitive programming but sometimes I also use c++. I am interested in AI and ML but I am learning them at a very early stage.",
        socialMedia: ['https://github.com/Ranit6', '', '', '', '']
    }
    ],
    magazineHead: [
        {
            name: "Upashana Pan",
            profession: "MERN Stack Developer",
            order: 8,
            clubRole: "Editor",
            dept: "IT",
            year: "3rd",
            skills: ['Web development', 'competitive programming', 'python', 'AI(very beginning stage)'],
            about: "Myself Ranit Das and currently I am working with web development. I have also done some competitive programming. I actually use python and c in competitive programming but sometimes I also use c++. I am interested in AI and ML but I am learning them at a very early stage.",
            socialMedia: ['https://github.com/Upasana-610', 'https://www.linkedin.com/in/upasana-pan-610upa', '', '', '']
        }
    ]
}
